<form [formGroup]="newFacilityFG" class="component-container new-facility-container">
  <div *ngIf="!hideMeasuringPointOperator" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows form-font-size">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
      <label class="ui-g-5 field-label text-right-align required" for="base-data-measuring-point">
        {{ 'facilities-data.form-fields.measuring-point-operator' | translate }}
      </label>
      <p-dropdown
        (onChange)="onOperatorChange($event)"
        [options]="measuringPointOperators"
        formControlName="measuringPointOperator"
        id="base-data-measuring-point"
        placeholder="-Select-"
        [readonly]="isReadOnly">
        <ng-template let-item pTemplate="selectedItem">
          <span class="drop-item-label">{{ 'lookup.' + measuringPointKey + '.options.' + item['value'] + '.name' | translate }}</span>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="drop-item">
            <span class="drop-item-label">{{ 'lookup.' + measuringPointKey + '.options.' + option['value'] + '.name' | translate }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <div *ngIf="showMeasuringPointNote" class="field-label">
        {{ 'facilities-data.measuring-point-operator-note' | translate }}
      </div>
    </div>

    <div *ngIf="getMeasuringPointOperator === 'other'" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows top-padding">
      <label class="ui-g-5 field-label text-right-align required">{{ 'facilities-data.form-fields.company' | translate }}</label>
      <input
        class="ui-input pInputText"
        formControlName="company"
        id="base-data-company-input"
        maxlength="50"
        pInputText
        size="30"
        type="text"
        [readonly]="isReadOnly" />
    </div>
  </div>
</form>
